// Canonical brand URL — overridable per environment via REACT_APP_SITE_URL.
// Defaults to the production domain so SEO/JSON-LD always emit the
// canonical URL the brand should be indexed under, even on first deploy.
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://weightlossgurukul.in"
).replace(/\/+$/, ""); // strip trailing slash

export const SITE_HOST = SITE_URL.replace(/^https?:\/\//i, "");

// Build an absolute URL from a path or pass-through if already absolute.
export const absUrl = (pathOrUrl = "/") => {
  if (!pathOrUrl) return SITE_URL;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith("/") ? "" : "/"}${pathOrUrl}`;
};

// True only on the canonical production host. Used to auto-noindex
// preview / staging environments so they never compete in Google's index.
export const isCanonicalHost = () => {
  if (typeof window === "undefined") return true;
  return window.location.host === SITE_HOST;
};
